<template>
    <vue-fab autoHideDirection="down" fabItemAnimate="default" size="normal"  :mainBtnColor="'#f4364c'" icon="translate" :style="{ bottom: '120px', left: '20px'}">
        <template v-for="(item, index) in items">
            <fab-item :key="index" @clickItem="clickItem(item.mode)" :idx="index">
                <img :src="require(`@/assets/banderas/${item.image}`)" style="width: 100%;border-radius: 50%" />
            </fab-item>
        </template>
    </vue-fab>
</template>

<script setup>
    import { ref } from 'vue';
    import { getI18n } from '@/utils/i18n-helper';

    const i18n = getI18n();
    const items = [
        { title: "Español", image: "esp.png", mode: "es" },
        { title: "English", image: "eng.png", mode: "en" },
        { title: "Catalá",  image: "ca.png",  mode: "ca" },
        { title: "Galego",  image: "gl.png",  mode: "gl" },
        { title: "Valenciano", image: "va.png", mode: "va" },
    ];

    const clickItem = idioma => {
        i18n.locale = idioma;
        localStorage.setItem('lang', idioma);
    }
</script>

